import React, { useEffect, useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import logo from './assets/OS logo inverted.png';
import mailIcon from './assets/mail-icon.png';
import instagramIcon from './assets/instagram-icon.png';
import Loader from './Loader';
import NewsletterPage from './NewsletterPage';
import ConstitutionPage from './ConstitutionPage';
import AboutPage from './AboutPage';
import EventsPage from './EventsPage';
import './App.css';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore/lite';
import { doc, getDoc } from 'firebase/firestore/lite';

const API_KEY = 'AIzaSyBaaZ7o7ChVmdnLLPTOTHXZdA7QQeqt4BI';

const firebaseConfig = {
  apiKey: 'AIzaSyCf2Gkwe8jIeZKe3g6pN0g4bWIySj3WwBs',
  authDomain: 'outer-spaces-44697.firebaseapp.com',
  projectId: 'outer-spaces-44697',
  storageBucket: 'outer-spaces-44697.firebasestorage.app',
  messagingSenderId: '466527242122',
  appId: '1:466527242122:web:170e40fe1ea1ac248b6a73',
  measurementId: 'G-B46CXC235V',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function App() {
  const [videos, setVideos] = useState([]); // Ensure videos is initialized as an empty array
  const [email, setEmail] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const videosPerPage = 9;

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Fetch email from Firestore
        const configRef = doc(db, 'config', 'email');
        const configSnap = await getDoc(configRef);

        if (configSnap.exists()) {
          setEmail(configSnap.data().email);
        } else {
          console.warn('No Firestore document found for email.');
        }
      } catch (error) {
        console.error('Failed to fetch email', error);
      }
    };

    const fetchVideos = async () => {
      try {
        setLoading(true);
        // Step 1: Get Channel ID from Firestore
        const docRef = doc(db, 'config', 'youtube');
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          throw new Error('No Firestore document found for channel ID.');
        }

        const channelId = docSnap.data().channelId;

        // Step 2: Get Uploads Playlist ID using Channel ID
        const channelRes = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${channelId}&key=${API_KEY}`
        );
        const channelData = await channelRes.json();
        if (!channelData.items || channelData.items.length === 0) {
          throw new Error('No channel data found. Please check the channel ID.');
        }
        const uploadsPlaylistId =
          channelData.items[0].contentDetails.relatedPlaylists.uploads;

        // Step 3: Get all videos from Uploads Playlist using pagination
        let allVideos = [];
        let nextPageToken = '';
        
        do {
          const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${uploadsPlaylistId}&key=${API_KEY}${nextPageToken ? `&pageToken=${nextPageToken}` : ''}`;
          
          const playlistRes = await fetch(url);
          const playlistData = await playlistRes.json();
          
          if (playlistData.items) {
            allVideos = [...allVideos, ...playlistData.items];
          }
          
          nextPageToken = playlistData.nextPageToken || '';
        } while (nextPageToken);
        
        setVideos(allVideos);
      } catch (error) {
        console.error('Failed to fetch videos', error);
        setVideos([]); // Fallback to an empty array on error
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
    fetchVideos();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(videos.length / videosPerPage);
  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = videos.slice(indexOfFirstVideo, indexOfLastVideo);

  const goToPage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  console.log('Videos:', videos);
  console.log('Email:', email);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="App">
            <header className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <h1>Outer Spaces Sessions</h1>
              <div className="social-links">
                <a href={`mailto:${email}`} className="mail-link">
                  <img src={mailIcon} alt="Mail Icon" className="mail-icon" />
                </a>
                <a
                  href="https://www.instagram.com/outer_spaces_sessions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="instagram-link"
                >
                  <img
                    src={instagramIcon}
                    alt="Instagram Icon"
                    className="instagram-icon"
                  />
                </a>
              </div>
              <Link to="/newsletter" className="newsletter-button">
                Subscribe to Newsletter
              </Link>
              <Link to="/events" className="events-button">
                View Events
              </Link>
              {loading ? (
                <div className="coming-soon">
                  <Loader />
                  <p>Loading sessions...</p>
                </div>
              ) : videos.length === 0 ? (
                <div className="coming-soon">
                  <p>No sessions found.</p>
                </div>
              ) : (
                <>
                  <p className="video-count">
                    Showing {indexOfFirstVideo + 1}-{Math.min(indexOfLastVideo, videos.length)} of {videos.length} sessions
                  </p>
                  <div className="videos-grid">
                    {currentVideos.map((video) => (
                      <div key={video.id} className="video-item">
                      <h2>{video.snippet.title}</h2>
                      <div className="thumbnail-container">
                        {video.showIframe ? (
                          <iframe
                            className={video.showIframe ? '' : 'hidden'}
                            src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                            title={video.snippet.title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        ) : (
                          <div
                            className={`thumbnail ${video.showIframe ? 'hidden' : ''}`}
                            onClick={() => {
                              setVideos((prevVideos) =>
                                prevVideos.map((v) =>
                                  v.id === video.id ? { ...v, showIframe: true } : v
                                )
                              );
                            }}
                          >
                            <img
                              src={
                                video.snippet.thumbnails.maxres?.url ||
                                video.snippet.thumbnails.high?.url ||
                                video.snippet.thumbnails.medium.url
                              }
                              alt={video.snippet.title}
                            />
                            <div className="play-icon">▶</div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  </div>
                  {totalPages > 1 && (
                    <div className="pagination">
                      <button 
                        onClick={() => goToPage(1)} 
                        disabled={currentPage === 1}
                        className="pagination-btn pagination-nav"
                      >
                        ← First
                      </button>
                      <div className="pagination-pages">
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                          <button
                            key={page}
                            onClick={() => goToPage(page)}
                            className={`pagination-btn pagination-num ${currentPage === page ? 'active' : ''}`}
                          >
                            {page}
                          </button>
                        ))}
                      </div>
                      <button 
                        onClick={() => goToPage(totalPages)} 
                        disabled={currentPage === totalPages}
                        className="pagination-btn pagination-nav"
                      >
                        Last →
                      </button>
                    </div>
                  )}
                </>
              )}
            </header>
          </div>
        }
      />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/newsletter" element={<NewsletterPage />} />
      <Route path="/constitution" element={<ConstitutionPage />} />
      <Route path="/about" element={<AboutPage />} />
    </Routes>
  );
}

export default App;
